import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Employee from "./Employee";
import Dependant from "./Dependant";
import HealthQuestions from "./HealthQuestions";
import PersonalDataConsent from "./PersonalDataConsent";
import Declaration from "./Declaration";

const StyledForm = ({ isReadOnly, renderValue }) => (
  <div style={{ padding: 10, fontSize: "10pt", color: "black" }}>
    <Header />
    <Employee renderValue={renderValue} />
    <Dependant renderValue={renderValue} />
    <HealthQuestions />
    <PersonalDataConsent />
    <Declaration isReadOnly={isReadOnly} renderValue={renderValue} />
  </div>
);

StyledForm.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  renderValue: PropTypes.func.isRequired,
};

export default StyledForm;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/AVIVAHD201910/index.js